function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "eat_tools"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m12 3c0-.553-.447-1-1-1s-1 .447-1 1v4c0 .552-.448 1-1 1v-5c0-.553-.447-1-1-1s-1 .447-1 1v5c-.552 0-1-.448-1-1v-4c0-.553-.447-1-1-1s-1 .447-1 1v4c0 1.654 1.346 3 3 3v11c0 .553.447 1 1 1s1-.447 1-1v-11c1.654 0 3-1.346 3-3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m17 13.098v-10.098c0-.553-.447-1-1-1s-1 .447-1 1v10.098c-1.894.355-3 1.754-3 3.902 0 2.757 1.794 5 4 5s4-2.243 4-5c0-2.148-1.106-3.547-3-3.902zm-1 6.902c-1.084 0-2-1.374-2-3 0-1.383.617-2 2-2s2 .617 2 2c0 1.626-.916 3-2 3z"
})));

var Svg042Spoonandfork = function Svg042Spoonandfork(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg042Spoonandfork, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/042-spoon and fork.fbaea547.svg";
export { ForwardRef as ReactComponent };